@use '../../styling/colors.scss' as *;
@use '../../styling/typography.scss' as *;

.Mark {
  @extend %font-family-primary;

  background-color: $color-primary-purple-light;
  color: $color-primary-black;
}
